import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestDemo } from '../interfaces/landing.interfaces';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LandingService {
  private apiUrl: string;

  constructor(private http: HttpClient) {
    this.apiUrl = environment.api_url;
  }

  public requestDemo(requestData: RequestDemo): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.post(
      `${this.apiUrl}/public/forms/request-demo`,
      requestData,
      {
        headers,
      }
    );
  }
}
